/**
 * Dynamically get color from given colorlist
 * @param colorList
 * @param counter
 * @param divider
 * @return string
 */
export const getColor = (colorList: string[], counter: number): string => {
    return colorList[counter % colorList.length]
}
